export default "__VITE_ASSET__uwQIE2vV__"